import React from 'react';

const VersionHistoryModal = ({
  isOpen,
  onClose,
  versionHistory,
  onRestoreVersion
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg w-96 max-h-96">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-semibold">Version History</h3>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
          >
            ×
          </button>
        </div>
        <div className="space-y-2 max-h-64 overflow-y-auto">
          {versionHistory.length === 0 ? (
            <p className="text-gray-500 text-center py-4">
              No versions saved yet
            </p>
          ) : (
            versionHistory.map((version) => (
              <div
                key={version.id}
                className="flex justify-between items-center p-3 border rounded hover:bg-gray-50"
              >
                <div>
                  <div className="text-sm font-medium">
                    {version.timestamp.toLocaleString()}
                  </div>
                  <div className="text-xs text-gray-500">
                    {version.wordCount} words
                  </div>
                </div>
                <button
                  onClick={() => onRestoreVersion(version)}
                  className="px-3 py-1 bg-blue-500 text-white rounded text-sm hover:bg-blue-600 transition-colors"
                >
                  Restore
                </button>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default VersionHistoryModal;